import './SituacaoCadastro.css';
import { useTranslation } from 'react-i18next';

function SituacaoCadastro({
    situacao
}) {

  const idSituacao = situacao === "Ativo" ? 1 : 2;
  const { t } = useTranslation();

  return (
    <p className={`ativo-inativo-texto sit-${idSituacao}`}>{t("situacao-" + idSituacao)}</p>
  )
}

export default SituacaoCadastro;